import { graphql, useFragment } from 'react-relay';

import ProjectProgress from '../measure/ProjectProgress';
import { type FlexibleProjectProgress_project$key } from './__generated__/FlexibleProjectProgress_project.graphql';

const FlexibleProjectProgressFragmentGql = graphql`
  fragment FlexibleProjectProgress_project on Project {
    progress {
      completedCount
      totalCount
    }
  }
`;

export default function FlexibleProjectProgress({
  projectRef,
}: {
  projectRef: FlexibleProjectProgress_project$key;
}) {
  const project = useFragment(FlexibleProjectProgressFragmentGql, projectRef);
  const { completedCount, totalCount } = project.progress;

  return (
    <ProjectProgress numCompleted={completedCount} numTotal={totalCount} />
  );
}
